export default __webpack_public_path__ + "static/media/proj-02-title.25585462.png";